import React, { useEffect } from "react"
import PropTypes from "prop-types"
import useProfileStore from "../profileStore"
import { emailValidatingRegex } from "../../../../booking/components/BookingJourney"

export default function ContactInfo({ labels, contactInfoRef }) {
  const { headingContactInformation, labelEmail, labelMobileNumber, errorMessageFieldRequired } = labels
  const {
    email,
    setEmail,
    oldEmail,
    setOldEmail,
    mobileNumber,
    setMobileNumber,
    isEmailValid,
    setIsEmailValid,
    isMobileValid,
    setIsMobileValid,
    mobileErrorMessage,
    setMobileErrorMessage,
  } = useProfileStore()

  useEffect(() => {
    handleEmailChange(email)
  }, [email])

  useEffect(() => {
    handleMobileChange(mobileNumber)
  }, [mobileNumber])

  const handleEmailChange = (email) => {
    const emailHasContent = emailValidatingRegex.test(email)

    if (emailHasContent) setIsEmailValid(true)
    else {
      setIsEmailValid(false)
    }
  }

  const handleMobileChange = (mobile) => {
    const mobileHasContent = mobile.length > 0
    const mobileNoIsDanish = mobile.includes("+45")

    if (!mobileHasContent) {
      setIsMobileValid(false)
      setMobileErrorMessage(labels.errorMessageFieldRequired)
    } else if (mobileHasContent && mobile.length >= 3 && !mobileNoIsDanish) {
      setIsMobileValid(false)
      setMobileErrorMessage(labels.invalidPhoneNumberMessage)
    } else if (mobileHasContent && mobileNoIsDanish) {
      setIsMobileValid(true)
    }
  }

  return (
    <div className="form--profile__contact" ref={contactInfoRef}>
      <div className="form__section form__section--no-border clearfix">
        <h4>{headingContactInformation}</h4>
        <div className="form__section__inner">
          <div className={`form__field form__field--text ${email ? "is-filled" : ""} ${isEmailValid ? "" : "is-invalid"}`}>
            <span className="form__valid"></span>
            <input
              id="form-email"
              name="Email"
              onChange={(e) => setEmail(e.target.value)}
              className="form__item "
              tabIndex=""
              type="email"
              value={email}
            ></input>
            <label htmlFor="form-email" className="form__label">
              <span className="form__label__text">
                {labelEmail}&nbsp;*&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
            {isEmailValid ? undefined : (
              <span id="emailFormError" className="form-notice">
                {errorMessageFieldRequired}
              </span>
            )}
          </div>
          <div id="phoneInputDiv" className={`form__field form__field--text ${mobileNumber ? "is-filled" : ""} ${isMobileValid ? "" : "is-invalid"}`}>
            <span className="form__valid"></span>
            <input
              id="form-mobilenumber"
              className="form__item "
              onChange={(e) => {
                setMobileNumber(e.target.value)
              }}
              name="Mobilenumber"
              tabIndex=""
              type="tel"
              value={mobileNumber}
            ></input>
            <label htmlFor="form-mobilenumber" className="form__label">
              <span className="form__label__text">
                {labelMobileNumber}&nbsp;*&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
            {isMobileValid ? undefined : (
              <span id="phoneNumberFormError" className="form-notice">
                {mobileErrorMessage}
              </span>
            )}
            {/* {}<span id="phoneNumberRequired" className="form-notice" hidden>{activationCodeRequiredMessage}</span> */}
          </div>
        </div>
      </div>
      <input name="OldEmail" value={oldEmail} onChange={(e) => setOldEmail(e.target.value)} hidden />
    </div>
  )
}

ContactInfo.propTypes = {
  labels: PropTypes.object.isRequired,
  contactInfoRef: PropTypes.object.isRequired,
}
